import _Object$assign from 'babel-runtime/core-js/object/assign';

import mixin from './mixin';
import Saturation from './Saturation.vue';
import Hue from './Hue.vue';
import Alpha from './Alpha.vue';
import Preview from './Preview.vue';
import Sucker from './Sucker.vue';
import Box from './Box.vue';
import Colors from './Colors.vue';
import Popper from 'element-ui/lib/utils/vue-popper';
import Locale from 'element-ui/lib/mixins/locale';

export default {
  components: {
    Saturation: Saturation,
    Hue: Hue,
    Alpha: Alpha,
    Preview: Preview,
    Sucker: Sucker,
    Box: Box,
    Colors: Colors
  },
  mixins: [mixin, Popper, Locale],
  props: {
    color: {
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    },
    alphaHide: {
      type: Boolean,
      default: false
    },
    showTextInput: {
      type: Boolean,
      default: false
    },
    colorsDefault: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    colorsHistoryKey: {
      type: String,
      default: 'vue-colorpicker-history'
    }
  },
  data: function data() {
    return {
      hueWidth: 15,
      hueHeight: 152,
      previewHeight: 30,
      modelRgba: '',
      modelHex: '',
      r: 0,
      g: 0,
      b: 0,
      a: 1,
      h: 0,
      s: 0,
      v: 0
    };
  },

  computed: {
    isLightTheme: function isLightTheme() {
      return this.theme === 'light';
    },
    totalWidth: function totalWidth() {
      return this.hueHeight + (this.hueWidth + 8) * 2;
    },
    previewWidth: function previewWidth() {
      return this.totalWidth - (this.suckerHide ? 0 : this.previewHeight);
    },
    rgba: function rgba() {
      return {
        r: this.r,
        g: this.g,
        b: this.b,
        a: this.a
      };
    },
    hsv: function hsv() {
      return {
        h: this.h,
        s: this.s,
        v: this.v
      };
    },
    rgbString: function rgbString() {
      return 'rgb(' + this.r + ', ' + this.g + ', ' + this.b + ')';
    },
    rgbaStringShort: function rgbaStringShort() {
      return this.r + ', ' + this.g + ', ' + this.b + ', ' + this.a;
    },
    rgbaString: function rgbaString() {
      return 'rgba(' + this.rgbaStringShort + ')';
    },
    hexString: function hexString() {
      return this.rgb2hex(this.rgba, true);
    },


    // 只要支持 EyeDropper API 就开启拾色功能，目前只有 Chrome 95 版本以上才支持
    suckerHide: function suckerHide() {
      return !window.EyeDropper;
    }
  },

  watch: {
    alphaHide: function alphaHide(val) {
      if (val) {
        this.resetAlpha();
      }
    },

    color: {
      immediate: true,
      deep: true,
      handler: function handler() {
        _Object$assign(this, this.setColorValue(this.color.value));
        this.setText();
      }
    }
  },

  methods: {
    selectSaturation: function selectSaturation(color) {
      var _setColorValue = this.setColorValue(color),
          r = _setColorValue.r,
          g = _setColorValue.g,
          b = _setColorValue.b,
          h = _setColorValue.h,
          s = _setColorValue.s,
          v = _setColorValue.v;

      _Object$assign(this, { r: r, g: g, b: b, h: h, s: s, v: v });
      this.setText();
    },
    selectHue: function selectHue(color) {
      var _this = this;

      var _setColorValue2 = this.setColorValue(color),
          r = _setColorValue2.r,
          g = _setColorValue2.g,
          b = _setColorValue2.b,
          h = _setColorValue2.h,
          s = _setColorValue2.s,
          v = _setColorValue2.v;

      _Object$assign(this, { r: r, g: g, b: b, h: h, s: s, v: v });
      this.setText();
      this.$nextTick(function () {
        _this.$refs.saturation.renderColor();
        _this.$refs.saturation.renderSlide();
      });
    },
    selectAlpha: function selectAlpha(a) {
      this.a = a;
      this.setText();
    },
    inputHex: function inputHex(color) {
      var _this2 = this;

      var _setColorValue3 = this.setColorValue(color),
          r = _setColorValue3.r,
          g = _setColorValue3.g,
          b = _setColorValue3.b,
          a = _setColorValue3.a,
          h = _setColorValue3.h,
          s = _setColorValue3.s,
          v = _setColorValue3.v;

      _Object$assign(this, { r: r, g: g, b: b, a: a, h: h, s: s, v: v });
      this.modelHex = color;
      this.modelRgba = this.rgbaStringShort;
      this.$nextTick(function () {
        _this2.$refs.saturation.renderColor();
        _this2.$refs.saturation.renderSlide();
        _this2.$refs.hue.renderSlide();
      });
    },
    inputRgba: function inputRgba(color) {
      var _this3 = this;

      var _setColorValue4 = this.setColorValue(color),
          r = _setColorValue4.r,
          g = _setColorValue4.g,
          b = _setColorValue4.b,
          a = _setColorValue4.a,
          h = _setColorValue4.h,
          s = _setColorValue4.s,
          v = _setColorValue4.v;

      _Object$assign(this, { r: r, g: g, b: b, a: a, h: h, s: s, v: v });
      this.modelHex = this.hexString;
      this.modelRgba = color;
      this.$nextTick(function () {
        _this3.$refs.saturation.renderColor();
        _this3.$refs.saturation.renderSlide();
        _this3.$refs.hue.renderSlide();
      });
    },
    setText: function setText() {
      this.modelHex = this.hexString;
      this.modelRgba = this.rgbaStringShort;
    },
    openSucker: function openSucker(isOpen) {
      this.$emit('openSucker', isOpen);
    },
    selectSucker: function selectSucker(color) {
      var _this4 = this;

      var _setColorValue5 = this.setColorValue(color),
          r = _setColorValue5.r,
          g = _setColorValue5.g,
          b = _setColorValue5.b,
          a = _setColorValue5.a,
          h = _setColorValue5.h,
          s = _setColorValue5.s,
          v = _setColorValue5.v;

      _Object$assign(this, { r: r, g: g, b: b, a: a, h: h, s: s, v: v });
      this.setText();
      this.$nextTick(function () {
        _this4.$refs.saturation.renderColor();
        _this4.$refs.saturation.renderSlide();
        _this4.$refs.hue.renderSlide();
      });
    },
    selectColor: function selectColor(color) {
      var _this5 = this;

      var _setColorValue6 = this.setColorValue(color),
          r = _setColorValue6.r,
          g = _setColorValue6.g,
          b = _setColorValue6.b,
          a = _setColorValue6.a,
          h = _setColorValue6.h,
          s = _setColorValue6.s,
          v = _setColorValue6.v;

      _Object$assign(this, { r: r, g: g, b: b, a: a, h: h, s: s, v: v });
      this.setText();
      this.$nextTick(function () {
        _this5.$refs.saturation.renderColor();
        _this5.$refs.saturation.renderSlide();
        _this5.$refs.hue.renderSlide();
      });
    },


    // 如果隐藏 aplha 选择器，需要把 alpha 设置为 1
    resetAlpha: function resetAlpha() {
      this.a = 1;
      this.setText();
    }
  },

  mounted: function mounted() {
    var _this6 = this;

    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;

    // 避免初始化时，也会触发changeColor事件
    this.$watch('rgba', function () {
      _this6.$emit('changeColor', {
        rgba: _this6.rgba,
        hsv: _this6.hsv,
        hex: _this6.modelHex
      });
    });
  }
};